import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo la guía después de comprar?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con un enlace seguro para descargar todos los tomos y bonos en formato PDF. Podés leerlos en tu celular, tablet o computadora, o imprimirlos si preferís el papel.'
}, {
  q: '¿Sirve si ya estamos avanzados en el embarazo o es solo para el primer trimestre?',
  a: '¡Sirve en cualquier momento! Aunque el Tomo 1 se enfoca en el inicio, las herramientas de comunicación, el mapa de emociones y las cartas de conversación son útiles sin importar en qué semana estén. Pueden adaptar los ejercicios a su situación actual.'
}, {
  q: '¿Esto es para leer juntos o cada uno por su lado?',
  a: 'El sistema está diseñado para ser flexible. Pueden leer los módulos juntos, o cada uno por su lado y luego usar los guiones y cartas de conversación como punto de encuentro. Lo importante es que ambos participen en los ejercicios prácticos.'
}, {
  q: '¿Los 3 bonos están incluidos en las dos ofertas?',
  a: 'Sí, tanto si elegís el plan Standard como el Pack Completo, te llevás los 3 bonos estratégicos (Mazo de Cartas, Guiones de Conversaciones Difíciles y Tracker de Nosotros) totalmente gratis.'
}, {
  q: '¿Sirve si mi pareja no es de hablar mucho de emociones?',
  a: "Especialmente diseñado para eso. El sistema no exige 'hablar por hablar', sino que provee estructuras claras, frases de entrada y ejercicios concretos (como el mapa de emociones) que facilitan la comunicación para quienes les cuesta abrirse sin una guía."
}, {
  q: '¿Sirve si ya tuvimos discusiones fuertes por esto?',
  a: "Sí. Los guiones de conversaciones difíciles y el enfoque en 'nombrar sin culpar' están pensados justamente para desarmar la defensiva y volver a conectar después de momentos de tensión o desconexión."
}, {
  q: '¿Qué diferencia tiene con leer artículos gratis sobre el tema?',
  a: "Los artículos gratis dan consejos vagos ('comuníquense más'). Este sistema da el CÓMO: ejercicios paso a paso, guiones exactos de qué decir, y un tracker para medir el progreso. Es un plan de acción, no solo teoría."
}, {
  q: '¿Por qué elegir el Pack Completo y no el Standard?',
  a: 'El Pack Completo cubre la etapa más crítica: el posparto. Muchas parejas logran ser equipo en el embarazo pero se quiebran con la falta de sueño y el bebé en casa. Los Tomos 4 y 5 les dan las herramientas para sostener la conexión en esa etapa.'
}, {
  q: '¿Tiene garantía real?',
  a: '100% real. Tienen 7 días desde la compra para revisar todo el material. Si sienten que no es para ustedes, nos escriben y les devolvemos el dinero sin hacer preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-24 px-4 md:px-8 bg-cream" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        <div className="text-center mb-3 md:mb-4" data-id="element-59">
          <span className="font-sans text-terracotta font-bold tracking-wider uppercase text-xs md:text-sm" data-id="element-60">
            Dudas Comunes
          </span>
        </div>
        <SectionHeading title="PREGUNTAS FRECUENTES" data-id="element-61" />

        <div className="space-y-3 md:space-y-4" data-id="element-62">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-offwhite rounded-2xl border border-brown/10 overflow-hidden" data-id="element-63">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full text-left p-4 md:p-6 flex items-center justify-between gap-3 md:gap-4 hover:bg-brown/[0.02] transition-colors" aria-expanded={isOpen} data-id="element-64">
                  <span className="font-serif font-bold text-brown text-base md:text-lg" data-id="element-65">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-terracotta transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-66" />
                </button>
                <AnimatePresence data-id="element-67">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-68">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-0" data-id="element-69">
                        <p className="font-sans text-sm md:text-base text-brown/70 leading-relaxed" data-id="element-70">
                          {faq.a}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}